import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import PfitzingerCalculator from './PfitzingerCalculator';

function Calculators() {
  const [activeTab, setActiveTab] = useState('marathon-pacer');

  return (
    <div className="calculators-section">
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-4"
      >
        <Tab
          eventKey="marathon-pacer"
          title={
            <span>
              <i className="fas fa-running me-2"></i>
              Marathon Pacer
            </span>
          }
        >
          <PfitzingerCalculator />
        </Tab>

        {/* Future calculators can be added here as new Tab components */}
        {/* Example:
        <Tab
          eventKey="race-predictor"
          title={
            <span>
              <i className="fas fa-trophy me-2"></i>
              Race Predictor
            </span>
          }
        >
          <RacePredictor />
        </Tab>
        */}
      </Tabs>
    </div>
  );
}

export default Calculators;
